import React from "react";
import ShopConfiguration from "../../Configuration";
import Storefront from "../../Storefront";
import ShopProducts from "../../Products";
import ShopInventory from "../../Inventory";
import ShopStaging from "../../Staging";
import ShopOrders from "../../Orders";

const PANEL_COMPONENTS: Record<string, React.ComponentType<any>> = {
  config: ShopConfiguration,
  storefront: Storefront,
  products: ShopProducts,
  inventory: ShopInventory,
  staging: ShopStaging,
  orders: ShopOrders,
};

interface ShopAppPanelProps {
  panel: string;
  shop: any;
  order: any;
  popups: any[];
}

export default function ShopAppPanel({
  panel,
  shop,
  order,
  popups,
}: ShopAppPanelProps) {
  const PanelComponent = PANEL_COMPONENTS[panel];
  if (!PanelComponent || !shop) return null;

  return (
    <PanelComponent
      shop={shop}
      order={order}
      shop_id={shop.shop_id}
      {...(panel === "storefront" ? { popups } : {})}
    />
  );
}
